import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export interface DownloadFile {
  key: string;
  url: string;
  size: number;
  lastModified: string;
  etag: string;
  fileName: string;
}

export interface UploadResponse {
  code: number;
  message: string;
  data: {
    key: string;
    file_name: string;
    file_url: string;
    file_size: number;
  };
}

@Injectable({
  providedIn: 'root',
})
export class DownloadsService {
  private baseUrl = `${environment.BASE_URL}/mobile`;

  constructor(private http: HttpClient) {}

  /**
   * Upload APK file to S3
   */
  uploadApkFile(file: File): Promise<UploadResponse> {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post<UploadResponse>(`${this.baseUrl}/build/upload`, formData).toPromise();
  }

  /**
   * Get all APK files from S3
   */
  getAllDownloadFiles(prefix?: string): Promise<DownloadFile[]> {
    const params: any = {};
    if (prefix) {
      params.prefix = prefix;
    }

    return this.http
      .get<{ code: number; message: string; data: DownloadFile[] }>(`${this.baseUrl}/builds`, { params })
      .toPromise()
      .then((response) => response.data || []);
  }

  /**
   * Download individual file from S3
   */
  downloadFile(key: string): Promise<Blob> {
    // Encode the key for URL query parameter
    const encodedKey = encodeURIComponent(key);
    return this.http
      .get(`${this.baseUrl}/build/download`, {
        params: { key: encodedKey },
        responseType: 'blob',
      })
      .toPromise();
  }

  /**
   * Delete file from S3
   */
  deleteDownloadFile(key: string): Promise<any> {
    // For path parameter with :key*, encode the entire key including slashes
    // The backend will decode it using decodeURIComponent
    const encodedKey = encodeURIComponent(key);
    return this.http
      .delete<{ code: number; message: string }>(`${this.baseUrl}/build/${encodedKey}`)
      .toPromise();
  }
}

